/**
 * @generated SignedSource<<b6e6aa936bc8ecada10bb503b7962d55>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type GetSitesQuery$variables = {};
export type GetSitesQuery$data = {
  readonly getSites: ReadonlyArray<{
    readonly address: string | null;
    readonly address2: string | null;
    readonly city: string | null;
    readonly id: string;
    readonly key: string;
    readonly name: string;
    readonly region: {
      readonly id: string;
      readonly name: string;
    } | null;
    readonly state: string | null;
    readonly zip: string | null;
  }>;
};
export type GetSitesQuery = {
  response: GetSitesQuery$data;
  variables: GetSitesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Site",
    "kind": "LinkedField",
    "name": "getSites",
    "plural": true,
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      },
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "address",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "address2",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "city",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "zip",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Region",
        "kind": "LinkedField",
        "name": "region",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "GetSitesQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "GetSitesQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "ec42808e08a0d2b5a799991438fdae6f",
    "id": null,
    "metadata": {},
    "name": "GetSitesQuery",
    "operationKind": "query",
    "text": "query GetSitesQuery {\n  getSites {\n    id\n    key\n    name\n    address\n    address2\n    city\n    state\n    zip\n    region {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d871636359091826f8c0753bae73e429";

export default node;
